import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  textContent: 'Please select an organization'
}
const _hoisted_2 = {
  key: 0,
  textContent: 'Please select an organization'
}
const _hoisted_3 = {
  key: 0,
  class: "w-full p-3 border-bottom-1 border-100"
}
const _hoisted_4 = { class: "font-bold text-red-600" }

import { ref, onBeforeMount, onUpdated, toRefs } from 'vue';
import UserRemoveReferral from './UserRemoveReferral.vue';
import Calendar from 'primevue/calendar';
import InputMask from 'primevue/inputmask';
import { EMIT, REFERRAL_TYPES, PERMISSIONS } from '@/enum';
import { can, useDateTime } from '@/composables';
import { ReferralProcessInterface, DisciplineStateInterface } from '@/types';
import { useStudentReferralStore, useClinicianOrganizationStore } from '@/store';
import { OrganizationBuildingInterface } from '@/types/BuildingInterface';

interface Props {
  save: boolean;
  organizationId?: number;
  buildings: OrganizationBuildingInterface[];
  disciplines: DisciplineStateInterface[];
  services: DisciplineStateInterface[];
}

const defaultTableRowLength = 1;

export default /*@__PURE__*/_defineComponent({
  __name: 'InitialEvalReferralTable',
  props: {
    save: { type: Boolean },
    organizationId: {},
    buildings: {},
    disciplines: {},
    services: {}
  },
  emits: [EMIT.SAVE],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const { save, organizationId, services } = toRefs(props);
const removeIndex = ref<number>(0);
const openRemove = ref<boolean>(false);

const referralStore = useStudentReferralStore();
const clinicianStore = useClinicianOrganizationStore();

const init = async () => {
  referralStore.initialEvalReferralTableData = [];
  for (let i = 0; i < 3; i++) makeBaseRow(i);
};

const makeBaseRow = (i: number) => {
  const referralType = REFERRAL_TYPES.INITIAL;
  const referralTypeId = referralStore.getReferralTypeId(referralType);
  const referral = referralStore.newRow(referralType);

  if (referral) {
    referral.referral_type.value = referralTypeId as number;
    referral.key = i;
    referralStore.initialEvalReferralTableData.push(referral);
  }
};

const validRow = (row) => {
  let valid = false;
  row.errors = null;
  const errorMessage = 'All required fields must be filled out.';

  if (row.row_status.completed) {
    return true;
  }

  if (row.id.value === '') {
    row.errors = null;
    return false;
  }

  if (
    row.id.value !== '' &&
    row.first_name.value !== '' &&
    row.last_name.value !== '' &&
    organizationId.value &&
    row.row_status.disable === false &&
    row.row_status.processing === false
  )
    valid = true;
  else if (
    !row.row_status.disable &&
    !row.row_status.processing &&
    (row.first_name.value !== '' || row.last_name.value !== '' || row.id.value !== '')
  ) {
    row.errors = errorMessage;
  }

  return valid;
};

onUpdated(async () => {
  if (save.value === true) {
    referralStore.initialEvalReferralTableData.forEach(async (row, index) => {
      if (!row.row_status.completed) {
        setTimeout(async () => {
          if (validRow(row)) {
            row.row_status.disable = true;
            row.row_status.processing = true;

            const payload: ReferralProcessInterface = {
              organization_id: organizationId.value as number,
              referral_type_id: row.referral_type.value,
              student_id: row.id.value,
              student_sis_id: row.student_sis_id.value,
              student_first_name: row.first_name.value,
              student_last_name: row.last_name.value,
              student_country: row.student_country.value,
              student_state: row.student_state.value,
              student_city: row.student_city.value,
              zipcode: row.zip.value,
              referred_discipline_id: row.referred_discipline.value,
              discipline_id: row.disciplines.value,
              building_campus: props.buildings.find((b) => b.id === row.location.value)?.name,
              building_id: row.location.value,
              gender: row.gender.value,
              birthdate: row.birthdate.value !== '' ? useDateTime().formatDateForApi(row.birthdate.value) : '',
              grade: row.grade.value,
              phone: row.phone.value,
              parent_sis_id: row.parent_sis_id.value,
              parent_first_name: row.parent_first_name.value,
              parent_last_name: row.parent_last_name.value,
              service_provider_id: row.service_provider.value,
              parent_email: row.parent_email.value,
              due_at: useDateTime().formatDateForApi(row.due_date.value),
              treatment_service_duration: 30,
              treatment_service_interval: 'daily',
              treatment_service_frequency: 1,
              integration_provider_type_slug: row.integration_provider_type_slug.value,
            };

            await referralStore.process(payload, index, REFERRAL_TYPES.INITIAL);

            handleProcessedRow(row);

            if (referralStore.error) referralStore.error = false;
          }
        }, index * 500);
      }
    });
    scrollBack();
    emit(EMIT.SAVE);
  }
});

const scrollBack = () => {
  const scrollableContainer = document.getElementById('initialTable');
  const childTable = scrollableContainer?.getElementsByClassName('p-datatable-wrapper');
  if (childTable)
    childTable[0]?.scroll({
      left: 0,
      behavior: 'smooth',
    });
};

const handleProcessedRow = (row) => {
  const errorLength = row.errors?.length;
  row.row_status.disable = !errorLength;
  row.row_status.completed = !errorLength;
  row.row_status.processing = false;

  if (!errorLength) row.errors = null;
};

const onUpdateRemove = () => {
  if (referralStore.initialEvalReferralTableData.length > defaultTableRowLength) {
    referralStore.initialEvalReferralTableData.splice(removeIndex.value, 1);
  }
};

const onRemoveRow = (index: number) => {
  if (referralStore.initialEvalReferralTableData.length > defaultTableRowLength) {
    removeIndex.value = index;
    openRemove.value = true;
  }
};

onBeforeMount(() => init());

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UserRemoveReferral, {
      open: openRemove.value,
      onUpdate: onUpdateRemove,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (openRemove.value = false))
    }, null, 8, ["open"]),
    _createVNode(_component_DataTable, {
      id: "initialTable",
      value: _unref(referralStore).initialEvalReferralTableData,
      class: "border-solid border-1 border-100 border-round-md",
      rows: _unref(referralStore).initialEvalReferralTableData.length,
      "data-key": "key",
      scrollable: "",
      "scroll-direction": "horizontal",
      "loading-icon": "logo-spinner",
      "responsive-layout": "scroll",
      "row-group-mode": "subheader",
      "group-rows-by": "key"
    }, {
      groupfooter: _withCtx((slotProps) => [
        (slotProps.data.errors)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Icon, {
                name: "subdirectory_arrow_right",
                class: "mr-2 text-base text-red-600"
              }),
              _createElementVNode("span", _hoisted_4, "Errors - " + _toDisplayString(slotProps.data.errors), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          style: {"max-width":"40px"},
          frozen: true
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Icon, {
              name: "add_circle",
              class: "add__row__icon cursor-pointer",
              onClick: makeBaseRow
            })
          ]),
          body: _withCtx(({ data, index }) => [
            (!data.row_status.processing && !data.row_status.completed)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  name: "remove_circle",
                  class: "remove__row__icon cursor-pointer",
                  value: data.id.value,
                  disabled: _unref(referralStore).mTSSReferralTableData.length < 2,
                  onClick: ($event: any) => (onRemoveRow(index))
                }, null, 8, ["value", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            (data.row_status.processing)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 1,
                  name: "cached",
                  class: "text-primary spin-cached"
                }))
              : _createCommentVNode("", true),
            (data.row_status.completed)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 2,
                  name: "check_circle",
                  class: "text-primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "referral_type",
          header: "Referral Type",
          "header-class": "required w-screen",
          frozen: true
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.referral_type.value,
              "onUpdate:modelValue": ($event: any) => ((data.referral_type.value) = $event),
              type: "secondary",
              options: _unref(referralStore).referralTypes,
              "option-label": "title",
              "option-value": "id",
              placeholder: "Referral Type",
              class: "w-full",
              disabled: data.row_status.disable,
              onChange: ($event: any) => (_unref(referralStore).onReferralTypeChange(data, _unref(REFERRAL_TYPES).INITIAL))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "id",
          header: "SSID",
          "header-class": "required",
          style: {"max-width":"150px"},
          frozen: true
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.id.value,
              "onUpdate:modelValue": ($event: any) => ((data.id.value) = $event),
              placeholder: "SSID",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "first_name",
          header: "Student First Name",
          "header-class": "required",
          style: {"width":"100px"},
          frozen: true
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.first_name.value,
              "onUpdate:modelValue": ($event: any) => ((data.first_name.value) = $event),
              placeholder: "Student First Name",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "last_name",
          header: "Student Last Name",
          "header-class": "required",
          style: {"width":"100px"},
          frozen: true
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.last_name.value,
              "onUpdate:modelValue": ($event: any) => ((data.last_name.value) = $event),
              placeholder: "Student Last Name",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "zip",
          header: "Zip Code",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.zip.value,
              "onUpdate:modelValue": ($event: any) => ((data.zip.value) = $event),
              "use-grouping": false,
              placeholder: "Zip Code",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        (__props.buildings && __props.buildings.length > 0)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              field: "location",
              header: "Building/Campus",
              style: {"width":"250px"}
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_Dropdown, {
                  modelValue: data.location.value,
                  "onUpdate:modelValue": ($event: any) => ((data.location.value) = $event),
                  options: __props.buildings,
                  "option-label": "name",
                  "option-value": "id",
                  placeholder: "Select Building/Campus",
                  class: "w-full",
                  disabled: data.row_status.disable
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          field: "referred_discipline",
          header: "Referred Discipline",
          "header-class": "w-screen",
          style: {"max-width":"250px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.referred_discipline.value,
              "onUpdate:modelValue": ($event: any) => ((data.referred_discipline.value) = $event),
              type: "secondary",
              options: props.disciplines,
              "option-label": "name",
              "option-value": "id",
              placeholder: "Select Discipline",
              class: "w-full",
              "append-to": "body"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "services",
          header: "Service",
          "header-class": "w-screen",
          style: {"max-width":"250px"}
        }, {
          body: _withCtx(({ data }) => [
            (!_unref(organizationId))
              ? (_openBlock(), _createElementBlock("span", _hoisted_1))
              : (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 1,
                  modelValue: data.disciplines.value,
                  "onUpdate:modelValue": ($event: any) => ((data.disciplines.value) = $event),
                  type: "secondary",
                  options: _unref(services),
                  "option-label": "name",
                  "option-value": "id",
                  placeholder: "Select Service",
                  class: "w-full",
                  disabled: data.row_status.disable,
                  "append-to": "body"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"]))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "due_date",
          header: "Due Date",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Calendar), {
              id: "due_date",
              modelValue: data.due_date.value,
              "onUpdate:modelValue": ($event: any) => ((data.due_date.value) = $event),
              placeholder: "mm/dd/yyyy",
              "date-format": "mm/dd/yy",
              "manual-input": true,
              class: "w-full",
              disabled: data.row_status.disable,
              "append-to": "body"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "gender",
          header: "Gender",
          style: {"max-width":"180px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.gender.value,
              "onUpdate:modelValue": ($event: any) => ((data.gender.value) = $event),
              type: "secondary",
              options: _unref(referralStore).genderOptions,
              "option-label": "name",
              "option-value": "value",
              placeholder: "Select Gender",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "birthdate",
          header: "Birth Date",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Calendar), {
              id: "birthdate",
              modelValue: data.birthdate.value,
              "onUpdate:modelValue": ($event: any) => ((data.birthdate.value) = $event),
              placeholder: "mm/dd/yyyy",
              "date-format": "mm/dd/yy",
              "max-date": new Date(),
              "manual-input": true,
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "max-date", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "grade",
          header: "Grade",
          style: {"max-width":"180px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.grade.value,
              "onUpdate:modelValue": ($event: any) => ((data.grade.value) = $event),
              type: "secondary",
              options: _unref(referralStore).gradeOptions,
              placeholder: "Select Grade",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "phone",
          header: "Phone",
          style: {"max-width":"160px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(InputMask), {
              id: "phone",
              modelValue: data.phone.value,
              "onUpdate:modelValue": ($event: any) => ((data.phone.value) = $event),
              mask: "(999) 999-9999",
              placeholder: "(999) 999-9999",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "parent_first_name",
          header: "Parent First Name",
          style: {"width":"100px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.parent_first_name.value,
              "onUpdate:modelValue": ($event: any) => ((data.parent_first_name.value) = $event),
              placeholder: "Parent First Name",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "parent_last_name",
          header: "Parent Last Name",
          style: {"width":"100px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.parent_last_name.value,
              "onUpdate:modelValue": ($event: any) => ((data.parent_last_name.value) = $event),
              placeholder: "Parent Last Name",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "parent_email",
          header: "Parent Email",
          style: {"width":"100px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.parent_email.value,
              "onUpdate:modelValue": ($event: any) => ((data.parent_email.value) = $event),
              placeholder: "Parent Email",
              class: "w-full",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        (_unref(can)([_unref(PERMISSIONS).REFERRAL_ASSIGN]))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 1,
              field: "service_provider",
              header: "Service Provider",
              style: {"min-width":"250px"}
            }, {
              body: _withCtx(({ data }) => [
                (!_unref(clinicianStore).clinicians || !_unref(clinicianStore).clinicians.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                  : (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 1,
                      modelValue: data.service_provider.value,
                      "onUpdate:modelValue": ($event: any) => ((data.service_provider.value) = $event),
                      type: "secondary",
                      options: _unref(clinicianStore).clinicians,
                      "option-label": "display_name",
                      "option-value": "id",
                      placeholder: "Select Service Provider",
                      class: "w-full",
                      disabled: data.row_status.disable
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "rows"])
  ], 64))
}
}

})